import { POSSIBLE_EXTENSIONS } from "@constants";
import { useSnapshot } from "valtio";

import React from "react";

import { getImageContentById } from "@helpers/general";

import { kioskStore } from "@pages/Kiosk/store";

type PropsType = {
    children: React.ReactNode;
    selectedMode?: string;
};

export function PreviewBackgroundWrapper({
    children,
    selectedMode,
}: PropsType): JSX.Element {
    const {
        project: {
            template: { pages },
        },
        kioskWays,
        navigationIndex,
        isPrm,
    } = useSnapshot(kioskStore);
    let filename = "";
    let extension = "";

    const isActiveBackground =
        ((
            pages.ways[kioskWays[navigationIndex].name] as
                | PageType
                | PaymentPageType
                | OrderTakingPageType
                | PrinterOptionsPageType
                | ConsommationPageType
        )?.background?.active as boolean) ?? false;

    if (selectedMode !== undefined && selectedMode !== "") {
        filename = getImageContentById(
            (pages.subSteps[selectedMode as string] as PageType).background
                .id as string
        );
        extension = filename.split(".")[filename.split(".").length - 1];
    } else if (selectedMode === undefined) {
        filename = getImageContentById(
            (
                pages.ways[kioskWays[navigationIndex].name] as
                    | PageType
                    | PaymentPageType
                    | OrderTakingPageType
                    | PrinterOptionsPageType
                    | ConsommationPageType
            )?.background?.id as string
        );
        extension = filename.split(".")[filename.split(".").length - 1];
    }
    return isActiveBackground ? (
        <React.Fragment>
            {POSSIBLE_EXTENSIONS.includes(extension) ? (
                <React.Fragment>
                    <video
                        autoPlay={true}
                        muted={true}
                        loop={true}
                        style={{
                            objectFit: "cover",
                            height:
                                isPrm &&
                                kioskWays[navigationIndex].name !==
                                    "finalMessage" &&
                                kioskWays[navigationIndex].name !== "payment" &&
                                kioskWays[navigationIndex].name !==
                                    "loyaltyConsommation" &&
                                kioskWays[navigationIndex].name !==
                                    "salesMethods"
                                    ? "920px"
                                    : isPrm &&
                                      kioskWays[navigationIndex].name ===
                                          "salesMethods"
                                    ? "1920px"
                                    : "100%",
                            width: "100%",
                            position: "fixed",
                            zIndex: -2,
                        }}
                    >
                        <source src={filename} />
                    </video>
                    {children}
                </React.Fragment>
            ) : (
                <div
                    style={{
                        backgroundImage: `url('${filename}')`,
                        backgroundSize: "100% 100%",
                        height:
                            isPrm &&
                            kioskWays[navigationIndex].name !==
                                "finalMessage" &&
                            kioskWays[navigationIndex].name !== "payment" &&
                            kioskWays[navigationIndex].name !==
                                "loyaltyConsommation" &&
                            kioskWays[navigationIndex].name !== "salesMethods"
                                ? "920px"
                                : isPrm &&
                                  kioskWays[navigationIndex].name ===
                                      "salesMethods"
                                ? "1920px"
                                : "100%",
                        width: "100%",
                        zIndex:
                            kioskWays[navigationIndex].name === "salesMethods"
                                ? "unset"
                                : -2,
                    }}
                >
                    {children}
                </div>
            )}
        </React.Fragment>
    ) : (
        <React.Fragment>{children}</React.Fragment>
    );
}
